<template>
  <div class="tobepaid">
    <div class="tobepaidTabs">
      <el-tabs v-model="activeName" type="card" @tab-click="handleTabsClick">
        <el-tab-pane label="待支付" name="first"></el-tab-pane>
        <el-tab-pane label="已支付" name="second"></el-tab-pane>
        <el-tab-pane label="已取消" name="third"></el-tab-pane>
        <el-tab-pane label="全部订单" name="fourth"></el-tab-pane>
      </el-tabs>
    </div>
    <div class="tobepaidMain">
      <el-table :data="tableDataList" style="width: 100%" height="300">
        <el-table-column prop="orderCode" label="订单号" width="155">
        </el-table-column>
        <el-table-column prop="orderName" label="产品名称" width="130">
        </el-table-column>
        <el-table-column prop="orderNameChild" label="子产品名称" width="180">
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="160">
        </el-table-column>
        <el-table-column prop="orderStatus" label="状态" width="80">
        </el-table-column>
        <el-table-column prop="price" label="金额（元）" width="100">
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              @click="handleTableClick(scope.row)"
              type="text"
              size="small"
              >查看</el-button
            >

            <el-button type="text" size="small">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="tableData.length"
        background
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      activeName: 'first',
      tableData: [
        {
          orderCode: '1',
          orderName: 'ICP许可证申请',
          orderNameChild: 'ICP许可证申请-自助申请',
          createTime: '2016-10-12 10:00:00',
          orderStatus: '待支付',
          price: '1000.00'
        },
        {
          orderCode: '2',
          orderName: 'ICP许可证申请',
          orderNameChild: 'ICP许可证申请-自助申请',
          createTime: '2016-10-12 10:00:00',
          orderStatus: '待支付',
          price: '1000.00'
        },
        {
          orderCode: '3',
          orderName: 'ICP许可证申请',
          orderNameChild: 'ICP许可证申请-自助申请',
          createTime: '2016-10-12 10:00:00',
          orderStatus: '待支付',
          price: '1000.00'
        },
        {
          orderCode: '4',
          orderName: 'ICP许可证申请',
          orderNameChild: 'ICP许可证申请-自助申请',
          createTime: '2016-10-12 10:00:00',
          orderStatus: '待支付',
          price: '1000.00'
        },
        {
          orderCode: '5',
          orderName: 'ICP许可证申请',
          orderNameChild: 'ICP许可证申请-自助申请',
          createTime: '2016-10-12 10:00:00',
          orderStatus: '待支付',
          price: '1000.00'
        },
        {
          orderCode: '6',
          orderName: 'ICP许可证申请',
          orderNameChild: 'ICP许可证申请-自助申请',
          createTime: '2016-10-12 10:00:00',
          orderStatus: '待支付',
          price: '1000.00'
        },
        {
          orderCode: '7',
          orderName: 'ICP许可证申请',
          orderNameChild: 'ICP许可证申请-自助申请',
          createTime: '2016-10-12 10:00:00',
          orderStatus: '待支付',
          price: '1000.00'
        },
        {
          orderCode: 'ICP2020010101',
          orderName: 'ICP许可证申请',
          orderNameChild: 'ICP许可证申请-自助申请',
          createTime: '2016-10-12 10:00:00',
          orderStatus: '待支付',
          price: '1000.00'
        },
        {
          orderCode: 'ICP2020010101',
          orderName: 'ICP许可证申请',
          orderNameChild: 'ICP许可证申请-自助申请',
          createTime: '2016-10-12 10:00:00',
          orderStatus: '待支付',
          price: '1000.00'
        },
        {
          orderCode: 'ICP2020010101',
          orderName: 'ICP许可证申请',
          orderNameChild: 'ICP许可证申请-自助申请',
          createTime: '2016-10-12 10:00:00',
          orderStatus: '待支付',
          price: '1000.00'
        },
        {
          orderCode: '7',
          orderName: 'ICP许可证申请',
          orderNameChild: 'ICP许可证申请-自助申请',
          createTime: '2016-10-12 10:00:00',
          orderStatus: '待支付',
          price: '1000.00'
        },
        {
          orderCode: 'ICP2020010101',
          orderName: 'ICP许可证申请',
          orderNameChild: 'ICP许可证申请-自助申请',
          createTime: '2016-10-12 10:00:00',
          orderStatus: '待支付',
          price: '1000.00'
        },
        {
          orderCode: '7',
          orderName: 'ICP许可证申请',
          orderNameChild: 'ICP许可证申请-自助申请',
          createTime: '2016-10-12 10:00:00',
          orderStatus: '待支付',
          price: '1000.00'
        },
        {
          orderCode: '9',
          orderName: 'ICP许可证申请',
          orderNameChild: 'ICP许可证申请-自助申请',
          createTime: '2016-10-12 10:00:00',
          orderStatus: '待支付',
          price: '1000.00'
        },
        {
          orderCode: '8',
          orderName: 'ICP许可证申请',
          orderNameChild: 'ICP许可证申请-自助申请',
          createTime: '2016-10-12 10:00:00',
          orderStatus: '待支付',
          price: '1000.00'
        },
        {
          orderCode: '8',
          orderName: 'ICP许可证申请',
          orderNameChild: 'ICP许可证申请-自助申请',
          createTime: '2016-10-12 10:00:00',
          orderStatus: '待支付',
          price: '1000.00'
        },
        {
          orderCode: '2',
          orderName: 'ICP许可证申请',
          orderNameChild: 'ICP许可证申请-自助申请',
          createTime: '2016-10-12 10:00:00',
          orderStatus: '待支付',
          price: '1000.00'
        },
        {
          orderCode: '5',
          orderName: 'ICP许可证申请',
          orderNameChild: 'ICP许可证申请-自助申请',
          createTime: '2016-10-12 10:00:00',
          orderStatus: '待支付',
          price: '1000.00'
        },
        {
          orderCode: '5',
          orderName: 'ICP许可证申请',
          orderNameChild: 'ICP许可证申请-自助申请',
          createTime: '2016-10-12 10:00:00',
          orderStatus: '待支付',
          price: '1000.00'
        },
        {
          orderCode: '6',
          orderName: 'ICP许可证申请',
          orderNameChild: 'ICP许可证申请-自助申请',
          createTime: '2016-10-12 10:00:00',
          orderStatus: '待支付',
          price: '1000.00'
        },
        {
          orderCode: '3',
          orderName: 'ICP许可证申请',
          orderNameChild: 'ICP许可证申请-自助申请',
          createTime: '2016-10-12 10:00:00',
          orderStatus: '待支付',
          price: '1000.00'
        },
        {
          orderCode: '54353',
          orderName: 'ICP许可证申请',
          orderNameChild: 'ICP许可证申请-自助申请',
          createTime: '2016-10-12 10:00:00',
          orderStatus: '待支付',
          price: '1000.00'
        },
        {
          orderCode: '2342',
          orderName: 'ICP许可证申请',
          orderNameChild: 'ICP许可证申请-自助申请',
          createTime: '2016-10-12 10:00:00',
          orderStatus: '待支付',
          price: '1000.00'
        },
        {
          orderCode: '1231231',
          orderName: 'ICP许可证申请',
          orderNameChild: 'ICP许可证申请-自助申请',
          createTime: '2016-10-12 10:00:00',
          orderStatus: '待支付',
          price: '1000.00'
        },
        {
          orderCode: '7657567',
          orderName: 'ICP许可证申请',
          orderNameChild: 'ICP许可证申请-自助申请',
          createTime: '2016-10-12 10:00:00',
          orderStatus: '待支付',
          price: '1000.00'
        },
        {
          orderCode: '87685645',
          orderName: 'ICP许可证申请',
          orderNameChild: 'ICP许可证申请-自助申请',
          createTime: '2016-10-12 10:00:00',
          orderStatus: '待支付',
          price: '1000.00'
        },
        {
          orderCode: '345345',
          orderName: 'ICP许可证申请',
          orderNameChild: 'ICP许可证申请-自助申请',
          createTime: '2016-10-12 10:00:00',
          orderStatus: '待支付',
          price: '1000.00'
        },
        {
          orderCode: '768768',
          orderName: 'ICP许可证申请',
          orderNameChild: 'ICP许可证申请-自助申请',
          createTime: '2016-10-12 10:00:00',
          orderStatus: '待支付',
          price: '1000.00'
        },
        {
          orderCode: '0898089089',
          orderName: 'ICP许可证申请',
          orderNameChild: 'ICP许可证申请-自助申请',
          createTime: '2016-10-12 10:00:00',
          orderStatus: '待支付',
          price: '1000.00'
        },
        {
          orderCode: '234535',
          orderName: 'ICP许可证申请',
          orderNameChild: 'ICP许可证申请-自助申请',
          createTime: '2016-10-12 10:00:00',
          orderStatus: '待支付',
          price: '1000.00'
        },
        {
          orderCode: 'ICP2020010101',
          orderName: 'ICP许可证申请',
          orderNameChild: 'ICP许可证申请-自助申请',
          createTime: '2016-10-12 10:00:00',
          orderStatus: '待支付',
          price: '1000.00'
        },
        {
          orderCode: '234324',
          orderName: 'ICP许可证申请',
          orderNameChild: 'ICP许可证申请-自助申请',
          createTime: '2016-10-12 10:00:00',
          orderStatus: '待支付',
          price: '1000.00'
        },
        {
          orderCode: 'ICP2020010101',
          orderName: 'ICP许可证申请',
          orderNameChild: 'ICP许可证申请-自助申请',
          createTime: '2016-10-12 10:00:00',
          orderStatus: '待支付',
          price: '1000.00'
        },
        {
          orderCode: '432423423',
          orderName: 'ICP许可证申请',
          orderNameChild: 'ICP许可证申请-自助申请',
          createTime: '2016-10-12 10:00:00',
          orderStatus: '待支付',
          price: '1000.00'
        },
        {
          orderCode: '234234',
          orderName: 'ICP许可证申请',
          orderNameChild: 'ICP许可证申请-自助申请',
          createTime: '2016-10-12 10:00:00',
          orderStatus: '待支付',
          price: '1000.00'
        },
        {
          orderCode: 'ICP2020010101',
          orderName: 'ICP许可证申请',
          orderNameChild: 'ICP许可证申请-自助申请',
          createTime: '2016-10-12 10:00:00',
          orderStatus: '待支付',
          price: '1000.00'
        },
        {
          orderCode: '567567567567',
          orderName: 'ICP许可证申请',
          orderNameChild: 'ICP许可证申请-自助申请',
          createTime: '2016-10-12 10:00:00',
          orderStatus: '待支付',
          price: '1000.00'
        },
        {
          orderCode: '22222222222',
          orderName: 'ICP许可证申请',
          orderNameChild: 'ICP许可证申请-自助申请',
          createTime: '2016-10-12 10:00:00',
          orderStatus: '待支付',
          price: '1000.00'
        },
        {
          orderCode: '11111111111',
          orderName: 'ICP许可证申请',
          orderNameChild: 'ICP许可证申请-自助申请',
          createTime: '2016-10-12 10:00:00',
          orderStatus: '待支付',
          price: '1000.00'
        },
        {
          orderCode: 'ICP2020010101',
          orderName: 'ICP许可证申请',
          orderNameChild: 'ICP许可证申请-自助申请',
          createTime: '2016-10-12 10:00:00',
          orderStatus: '待支付',
          price: '1000.00'
        }
      ],
      tableDataList: [],
      currentPage: 1,
      pageSize: 10
    };
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.handleCurrentChange(1);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      let list = JSON.parse(JSON.stringify(this.tableData));
      this.tableDataList = list.splice(
        (this.currentPage - 1) * this.pageSize,
        this.pageSize
      );
    },
    handleTabsClick(tab, event) {
      console.log(tab, event);
    },
    handleTableClick(row) {
      console.log(row);
    }
  },
  mounted() {
    this.handleCurrentChange(1);
  }
};
</script>

<style lang="scss">
.tobepaid {
  width: 100%;
  height: 100%;
  padding: 30px 30px;
  display: flex;
  flex-direction: column;
  .tobepaidTabs {
    .el-tabs__item {
      padding: 10px !important;
      width: auto;
      height: auto;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(86, 86, 86, 1);
      line-height: 20px;
      background: #fafafa;
      border-bottom: 1px solid #e4e7ed;
    }
    .is-active {
      color: #ff6a00;
      background: #fff;
    }
  }
  .tobepaidMain {
    width: 100%;
    flex: 1;
    margin-top: 20px;
    overflow: auto;
    .el-table__header {
      .has-gutter {
        th {
          height: 54px;
          background: #fafafa;
          border-bottom: 1px solid #e8e8e8;
          .cell {
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: rgba(0, 0, 0, 0.85);
            line-height: 22px;
          }
        }
        th:nth-child(1) {
          padding-left: 15px;
        }
      }
    }
    .el-table__body {
      .el-table__row {
        td {
          height: 54px;
          background: #fff;
          border-bottom: 1px solid #e8e8e8;
          .cell {
            font-size: 13px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(89, 89, 89, 1);
            line-height: 22px;
          }
        }
        td:nth-child(1) {
          padding-left: 15px;
        }
      }
      .el-button--text {
        color: #ff6a00;
      }
    }
    .el-table__body-wrapper {
      height: calc(100% - 54px) !important;
    }
    .el-table--fit {
      height: 100% !important;
    }
    /*修改滚动条样式*/
    .el-table__body-wrapper::-webkit-scrollbar {
      width: 10px;
      height: 10px;
      /**/
    }
    .el-table__body-wrapper::-webkit-scrollbar-track {
      background: rgb(239, 239, 239);
      border-radius: 5px;
    }
    .el-table__body-wrapper::-webkit-scrollbar-thumb {
      background: #bfbfbf;
      border-radius: 10px;
    }
    .el-table__body-wrapper::-webkit-scrollbar-thumb:hover {
      background: #a8a8a8;
    }
    .el-table__body-wrapper::-webkit-scrollbar-corner {
      background: #179a16;
    }
  }
  .pagination {
    width: 100%;
    margin-top: 40px;
    display: flex;
    justify-content: flex-end;
    .el-pagination.is-background .el-pager li:not(.disabled).active {
      background: #ff6a00;
    }
    .el-pagination.is-background .el-pager li:not(.disabled):hover {
      color: #ff6a00;
    }
    .el-pagination.is-background .el-pager .active:not(.disabled):hover {
      color: #fff;
    }
    .el-select .el-input.is-focus .el-input__inner {
      border-color: #ff6a00;
    }
    .el-pagination__sizes .el-input .el-input__inner:hover {
      border-color: #ff6a00;
    }
    .el-select .el-input__inner:focus {
      border-color: #ff6a00;
    }
  }
}
.el-select-dropdown__item.selected {
  color: #ff6a00;
}
</style>
